<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de profissionais">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-imagem/reagendamento-cancelamento-exame/List'

export default {
    components: { List },
}
</script>